import React, { HTMLProps } from 'react'

import { Box, Stack, useRadio, InputProps, RadioProps } from '@chakra-ui/react'
import IconTodo from 'components/icons/TodoSquare'
import IconCheck from 'components/icons/DoneSquare'

const Component: React.FC<RadioProps> = ({ children, ...props }) => {
  const { getInputProps, getCheckboxProps } = useRadio(props)

  const input: Omit<HTMLProps<HTMLInputElement>, never> & InputProps = getInputProps()
  const checkbox = getCheckboxProps()

  return (
    <Box as="label" minH={8}>
      <input {...input} />
      <Stack spacing={2} direction="row">
        <Box {...checkbox} lineHeight="14px" alignSelf="flex-start">
          {input.checked ? <IconCheck /> : <IconTodo />}
        </Box>
        <Box>{children}</Box>
      </Stack>
    </Box>
  )
}

export default Component
